<template>
    <div v-if="text" class="truncated-text">
        <p :id="uniqueId" class="preserve-linebreaks truncated-text__content">{{ text }}</p>
        <template v-if="showMoreInfoBtn">
            <a v-if="isShowMoreLink" @click="$emit('click')">
                {{ $t('common.show_more_information') }}
            </a>
            <button
                v-else
                class="truncated-text__button button button--secondary-contrast button--small"
                @click="$emit('click')"
            >
                {{ $t('common.show_more_information') }}
            </button>
        </template>
    </div>
</template>

<script>
export default {
    name: 'TruncatedText',
    props: {
        text: {
            type: String,
            default: null,
        },
        isShowMoreLink: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            showMoreInfoBtn: false,
            uniqueId: null,
        };
    },
    mounted() {
        this.uniqueId = this.generateUniqueId();

        this.$nextTick(() => {
            this.shouldShowMoreInfoBtn();
        });
    },
    methods: {
        shouldShowMoreInfoBtn() {
            const truncateText = document.getElementById(this.uniqueId);

            if (truncateText) {
                const maxRows = 6;
                const lineHeight = parseInt(getComputedStyle(truncateText).lineHeight);

                if (truncateText.scrollHeight > maxRows * lineHeight) {
                    this.showMoreInfoBtn = true;
                }
            }
        },
        generateUniqueId() {
            const randomString = Math.random().toString(36).slice(2, 12);

            return `truncate-text-${randomString}`;
        },
    },
};
</script>

<style scoped lang="scss">
.truncated-text {
    &__content {
        overflow: hidden;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 6;
        word-wrap: break-word;
        text-overflow: ellipsis;
        max-height: 144px;
    }

    &__button {
        margin-top: 32px;
    }
}
</style>
